import React from "react";
import './index.scss';

export default () => (
  <div className="auth-intro">
    <h1 className="auth-intro__title">
      Accept <br/>
      <span className="clr--blue">cryptocurrency</span> <br/>
      payments <br/>
      easily <br/>
    </h1>
    <span className="auth-intro__subtitle">
      Online, In-Store and via Payment Link
    </span>
  </div>
)
